export var doesUrlMatch = function (path, search) {
    var regexp = new RegExp("/:locale(.*?)" + search + "$");
    return !!path.match(regexp);
};
